import AreaChart from "../../../../../src/core/AreaChart";
import { Playground } from 'docz';
import * as React from 'react';
export default {
  AreaChart,
  Playground,
  React
};